import {
  DRUM_IDS,
  DRUM_STEPS_PER_MEASURE,
  type DrumId,
  type DrumPattern,
} from '../types';

export function drumPatternLength(measures: number): number {
  return measures * DRUM_STEPS_PER_MEASURE;
}

export function createEmptyDrumPattern(measures = 1): DrumPattern {
  const len = drumPatternLength(measures);
  const row = () => Array<boolean>(len).fill(false);
  return {
    enabled: false,
    measures,
    steps: Object.fromEntries(DRUM_IDS.map((id) => [id, row()])) as Record<
      DrumId,
      boolean[]
    >,
  };
}

export function resizeDrumPattern(prev: DrumPattern, measures: number): DrumPattern {
  const nextLen = drumPatternLength(measures);
  const steps = Object.fromEntries(
    DRUM_IDS.map((id) => {
      const row = prev.steps[id] ?? [];
      if (row.length === nextLen) return [id, [...row]];
      if (row.length < nextLen) {
        return [id, [...row, ...Array(nextLen - row.length).fill(false)]];
      }
      return [id, row.slice(0, nextLen)];
    }),
  ) as Record<DrumId, boolean[]>;

  return { ...prev, measures, steps };
}

export function toggleDrumStep(
  pattern: DrumPattern,
  drum: DrumId,
  stepIndex: number,
): DrumPattern {
  const row = [...pattern.steps[drum]];
  if (stepIndex < 0 || stepIndex >= row.length) return pattern;
  row[stepIndex] = !row[stepIndex];
  return {
    ...pattern,
    steps: { ...pattern.steps, [drum]: row },
  };
}

export function clearDrumRow(pattern: DrumPattern, drum: DrumId): DrumPattern {
  return {
    ...pattern,
    steps: {
      ...pattern.steps,
      [drum]: pattern.steps[drum].map(() => false),
    },
  };
}

export function drumHitsAtStep(pattern: DrumPattern, stepIndex: number): DrumId[] {
  return DRUM_IDS.filter((id) => pattern.steps[id][stepIndex]);
}
